import mainLogo from '../../images/Iesa/grupo_iesa_logo_preta.png';
import squareLogo from '../../images/Iesa/grupo_iesa_logo_square_preta.png';
import bannerLogoWhite from '../../images/Iesa/grupo_iesa_logo_square_branca.png';
import banner01 from '../../images/Iesa/corp_faixa_2.jpg';
import banner02 from '../../images/Iesa/carros_faixa_cores_iesa.jpg';
import banner03 from '../../images/Iesa/corp_faixa_iesa_2.jpg';
import car123 from '../../images/Iesa/123_kardian.jpg';
import box123 from '../../images/Iesa/123_box_iesa.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Iesa',
    defaultStoreLink: 'loja.grupoiesa.com.br',
    defaultContactEmail: 'contato@grupoiesa.com.br',
    whatsappNumber: '51 9706 2361',
    CNPJname: 'RUAH VEICULOS LTDA',
    CNPJ: '04.130.692/0012-04',
    CNPJaddress: 'Av. Cruzeiro, 840 - Distrito Industrial, Cachoeirinha - RS, CEP: 94930-615',
    launchDate: '19/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "bmw",
        "fiat",
        "jeep",
        "nissan",
        "renault",
        "volvo",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Iesa Ipiranga",
        "Iesa BMW NH",
        "IESA MOPAR",
        "Iesa NISSAN LOG",
        "Iesa VOLVO Azenha",
        "Iesa NISSAN Canoas",
        "Iesa NISSAN Gravataí",
        "Iesa NISSAN NH",
        "Iesa NISSAN Osório",
        "Iesa NISSAN Tarso",
        "Iesa NISSAN Wenceslau",
        "Iesa JEEP Cachoeirinha",
        // "Iesa HARLEY Poa",
    ],

    disabledSellers: [
        "Iesa HARLEY Poa",
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    // pixDiscount: 0.05,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        // {
        //     name: 'Freios',
        //     img: 'tabFreios',
        //     products: SliderProducts.Freios
        // },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais compatíveis com <span style="font-weight: bold;">seu veículo</span>, direto das concessionárias <span style="font-weight: bold;">IESA</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo IESA é líder regional em seu segmento, sendo o maior e mais diversificado grupo automotivo do Rio Grande do Sul.',
        ],
        link: 'https://grupo4rodas.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupoiesa/',
        Facebook: 'https://www.facebook.com/GrupoIesaRS/',
        LinkedIn: 'https://www.linkedin.com/company/grupoiesa/',
        Youtube: 'https://www.youtube.com/c/GrupoIESAbrRS',
        Twitter: '',
    },

    footerContent: [],
}